import { FC } from 'react'
import { IconButton } from '@dtx-company/design-system/src'
import { Visibility, VisibilityOff } from '@mui/icons-material'

interface ActivateButtonProps {
  activated: boolean
  viewOnly: boolean
  toggleActivated: () => void
}

export const ActivateButton: FC<ActivateButtonProps> = ({
  activated,
  viewOnly,
  toggleActivated
}) => {
  return (
    <IconButton
      icon={activated ? Visibility : VisibilityOff}
      color="secondary"
      onClick={toggleActivated}
      disabled={viewOnly}
      data-testid="manager-activate-button"
      aria-label={`${activated ? 'deactivate' : 'activate'} widget`}
    />
  )
}
